import { render, staticRenderFns } from "./VisitServices.vue?vue&type=template&id=540654f6"
import script from "./VisitServices.vue?vue&type=script&lang=js"
export * from "./VisitServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports